import { useParams, Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

const universitiesData = [
  {
    id: 'harvard',
    name: 'Harvard University',
    location: 'Cambridge, Massachusetts',
    image: 'https://public.readdy.ai/ai/img_res/3abaa48325966773c5cff4f2323095c0.jpg',
    ranking: '#1 Mondial',
    rankingEn: '#1 Worldwide',
    founded: '1636',
    students: '23,000+',
    acceptance: '3.4%',
    tuition: '$54,000/an',
    tuitionEn: '$54,000/year',
    description: 'Harvard University est la plus ancienne institution d\'enseignement supérieur des États-Unis et l\'une des universités les plus prestigieuses au monde. Située à Cambridge, Massachusetts, Harvard offre une éducation d\'excellence dans tous les domaines académiques.',
    descriptionEn: 'Harvard University is the oldest institution of higher education in the United States and one of the most prestigious universities in the world. Located in Cambridge, Massachusetts, Harvard offers excellent education in all academic fields.',
    programs: [
      { name: 'Business Administration', nameFr: 'Administration des Affaires', degree: 'MBA, PhD', degreeFr: 'MBA, Doctorat' },
      { name: 'Law', nameFr: 'Droit', degree: 'JD, LLM', degreeFr: 'JD, LLM' },
      { name: 'Medicine', nameFr: 'Médecine', degree: 'MD, PhD', degreeFr: 'MD, Doctorat' },
      { name: 'Engineering', nameFr: 'Ingénierie', degree: 'MS, PhD', degreeFr: 'Master, Doctorat' },
      { name: 'Computer Science', nameFr: 'Informatique', degree: 'BS, MS, PhD', degreeFr: 'Licence, Master, Doctorat' },
      { name: 'Economics', nameFr: 'Économie', degree: 'BA, PhD', degreeFr: 'Licence, Doctorat' }
    ],
    requirements: {
      gpa: '3.9+',
      toefl: '100+',
      sat: '1460-1580',
      gre: '320+'
    },
    scholarships: [
      { name: 'Harvard Financial Aid', nameFr: 'Aide Financière Harvard', amount: 'Jusqu\'à 100%', amountEn: 'Up to 100%' },
      { name: 'International Scholarships', nameFr: 'Bourses Internationales', amount: '$10,000-$50,000', amountEn: '$10,000-$50,000' },
      { name: 'Merit-Based Awards', nameFr: 'Bourses au Mérite', amount: 'Variable', amountEn: 'Variable' }
    ],
    facilities: [
      { name: 'Bibliothèques', nameEn: 'Libraries', icon: 'ri-book-2-line' },
      { name: 'Laboratoires de Recherche', nameEn: 'Research Labs', icon: 'ri-flask-line' },
      { name: 'Centres Sportifs', nameEn: 'Sports Centers', icon: 'ri-basketball-line' },
      { name: 'Résidences Étudiantes', nameEn: 'Student Housing', icon: 'ri-home-4-line' },
      { name: 'Centres de Santé', nameEn: 'Health Centers', icon: 'ri-hospital-line' },
      { name: 'Centres Culturels', nameEn: 'Cultural Centers', icon: 'ri-palette-line' }
    ]
  },
  {
    id: 'stanford',
    name: 'Stanford University',
    location: 'Stanford, California',
    image: 'https://readdy.ai/api/search-image?query=Stanford%20University%20campus%20with%20Spanish%20colonial%20architecture%2C%20palm%20trees%20and%20sandstone%20buildings%2C%20Silicon%20Valley%20location%2C%20modern%20technology-focused%20university%20environment%2C%20sunny%20California%20weather%2C%20professional%20photography%20style&width=1200&height=600&seq=univ-detail-002&orientation=landscape',
    ranking: '#2 Mondial',
    rankingEn: '#2 Worldwide',
    founded: '1885',
    students: '17,000+',
    acceptance: '3.9%',
    tuition: '$56,000/an',
    tuitionEn: '$56,000/year',
    description: 'Stanford University est une université de recherche privée située au cœur de la Silicon Valley. Reconnue mondialement pour son excellence en ingénierie, informatique et entrepreneuriat, Stanford forme les leaders de demain.',
    descriptionEn: 'Stanford University is a private research university located in the heart of Silicon Valley. Globally recognized for its excellence in engineering, computer science and entrepreneurship, Stanford trains tomorrow\'s leaders.',
    programs: [
      { name: 'Computer Science', nameFr: 'Informatique', degree: 'BS, MS, PhD', degreeFr: 'Licence, Master, Doctorat' },
      { name: 'Engineering', nameFr: 'Ingénierie', degree: 'BS, MS, PhD', degreeFr: 'Licence, Master, Doctorat' },
      { name: 'Business', nameFr: 'Commerce', degree: 'MBA, PhD', degreeFr: 'MBA, Doctorat' },
      { name: 'Data Science', nameFr: 'Science des Données', degree: 'MS, PhD', degreeFr: 'Master, Doctorat' },
      { name: 'Artificial Intelligence', nameFr: 'Intelligence Artificielle', degree: 'MS, PhD', degreeFr: 'Master, Doctorat' },
      { name: 'Bioengineering', nameFr: 'Bio-ingénierie', degree: 'BS, MS, PhD', degreeFr: 'Licence, Master, Doctorat' }
    ],
    requirements: {
      gpa: '3.9+',
      toefl: '100+',
      sat: '1440-1570',
      gre: '325+'
    },
    scholarships: [
      { name: 'Stanford Financial Aid', nameFr: 'Aide Financière Stanford', amount: 'Jusqu\'à 100%', amountEn: 'Up to 100%' },
      { name: 'Knight-Hennessy Scholars', nameFr: 'Bourses Knight-Hennessy', amount: 'Complète', amountEn: 'Full Coverage' },
      { name: 'Graduate Fellowships', nameFr: 'Bourses de Cycles Supérieurs', amount: '$30,000-$50,000', amountEn: '$30,000-$50,000' }
    ],
    facilities: [
      { name: 'Bibliothèques', nameEn: 'Libraries', icon: 'ri-book-2-line' },
      { name: 'Laboratoires de Recherche', nameEn: 'Research Labs', icon: 'ri-flask-line' },
      { name: 'Centres Sportifs', nameEn: 'Sports Centers', icon: 'ri-basketball-line' },
      { name: 'Résidences Étudiantes', nameEn: 'Student Housing', icon: 'ri-home-4-line' },
      { name: 'Centres d\'Innovation', nameEn: 'Innovation Centers', icon: 'ri-lightbulb-line' },
      { name: 'Centres de Carrière', nameEn: 'Career Centers', icon: 'ri-briefcase-line' }
    ]
  },
  {
    id: 'mit',
    name: 'MIT',
    location: 'Cambridge, Massachusetts',
    image: 'https://readdy.ai/api/search-image?query=Massachusetts%20Institute%20of%20Technology%20MIT%20campus%20with%20modern%20architecture%20and%20iconic%20dome%20building%2C%20students%20with%20laptops%20and%20technology%2C%20innovative%20research%20environment%2C%20contemporary%20educational%20setting%2C%20professional%20photography&width=1200&height=600&seq=univ-detail-003&orientation=landscape',
    ranking: '#3 Mondial',
    rankingEn: '#3 Worldwide',
    founded: '1861',
    students: '11,500+',
    acceptance: '3.2%',
    tuition: '$55,000/an',
    tuitionEn: '$55,000/year',
    description: 'Le Massachusetts Institute of Technology (MIT) est une université de recherche privée de renommée mondiale, spécialisée dans les sciences, la technologie et l\'ingénierie. MIT est à la pointe de l\'innovation et de la recherche scientifique.',
    descriptionEn: 'The Massachusetts Institute of Technology (MIT) is a world-renowned private research university specializing in science, technology and engineering. MIT is at the forefront of innovation and scientific research.',
    programs: [
      { name: 'Computer Science', nameFr: 'Informatique', degree: 'BS, MS, PhD', degreeFr: 'Licence, Master, Doctorat' },
      { name: 'Electrical Engineering', nameFr: 'Génie Électrique', degree: 'BS, MS, PhD', degreeFr: 'Licence, Master, Doctorat' },
      { name: 'Mechanical Engineering', nameFr: 'Génie Mécanique', degree: 'BS, MS, PhD', degreeFr: 'Licence, Master, Doctorat' },
      { name: 'Physics', nameFr: 'Physique', degree: 'BS, PhD', degreeFr: 'Licence, Doctorat' },
      { name: 'Mathematics', nameFr: 'Mathématiques', degree: 'BS, PhD', degreeFr: 'Licence, Doctorat' },
      { name: 'Aerospace Engineering', nameFr: 'Génie Aérospatial', degree: 'BS, MS, PhD', degreeFr: 'Licence, Master, Doctorat' }
    ],
    requirements: {
      gpa: '3.9+',
      toefl: '100+',
      sat: '1500-1570',
      gre: '325+'
    },
    scholarships: [
      { name: 'MIT Financial Aid', nameFr: 'Aide Financière MIT', amount: 'Jusqu\'à 100%', amountEn: 'Up to 100%' },
      { name: 'International Scholarships', nameFr: 'Bourses Internationales', amount: '$15,000-$55,000', amountEn: '$15,000-$55,000' },
      { name: 'Research Assistantships', nameFr: 'Assistanats de Recherche', amount: 'Complète + Salaire', amountEn: 'Full + Stipend' }
    ],
    facilities: [
      { name: 'Bibliothèques', nameEn: 'Libraries', icon: 'ri-book-2-line' },
      { name: 'Laboratoires de Recherche', nameEn: 'Research Labs', icon: 'ri-flask-line' },
      { name: 'Centres Sportifs', nameEn: 'Sports Centers', icon: 'ri-basketball-line' },
      { name: 'Résidences Étudiantes', nameEn: 'Student Housing', icon: 'ri-home-4-line' },
      { name: 'Makerspaces', nameEn: 'Makerspaces', icon: 'ri-tools-line' },
      { name: 'Centres de Santé', nameEn: 'Health Centers', icon: 'ri-hospital-line' }
    ]
  },
  {
    id: 'columbia',
    name: 'Columbia University',
    location: 'New York, New York',
    image: 'https://readdy.ai/api/search-image?query=Columbia%20University%20campus%20in%20New%20York%20City%20with%20neoclassical%20buildings%20and%20urban%20setting%2C%20diverse%20students%20on%20campus%20grounds%2C%20Ivy%20League%20institution%2C%20metropolitan%20academic%20environment%2C%20professional%20photography%20style&width=1200&height=600&seq=univ-detail-004&orientation=landscape',
    ranking: '#6 Mondial',
    rankingEn: '#6 Worldwide',
    founded: '1754',
    students: '33,000+',
    acceptance: '3.7%',
    tuition: '$61,000/an',
    tuitionEn: '$61,000/year',
    description: 'Columbia University est une université de recherche privée de l\'Ivy League située au cœur de New York. Columbia offre une éducation d\'excellence dans les arts libéraux, le journalisme, le droit et les affaires, avec un accès unique aux opportunités de la ville de New York.',
    descriptionEn: 'Columbia University is a private Ivy League research university located in the heart of New York. Columbia offers excellent education in liberal arts, journalism, law and business, with unique access to New York City opportunities.',
    programs: [
      { name: 'Journalism', nameFr: 'Journalisme', degree: 'MS', degreeFr: 'Master' },
      { name: 'Business', nameFr: 'Commerce', degree: 'MBA, PhD', degreeFr: 'MBA, Doctorat' },
      { name: 'Law', nameFr: 'Droit', degree: 'JD, LLM', degreeFr: 'JD, LLM' },
      { name: 'International Affairs', nameFr: 'Affaires Internationales', degree: 'MIA, PhD', degreeFr: 'MIA, Doctorat' },
      { name: 'Liberal Arts', nameFr: 'Arts Libéraux', degree: 'BA, MA', degreeFr: 'Licence, Master' },
      { name: 'Public Health', nameFr: 'Santé Publique', degree: 'MPH, PhD', degreeFr: 'MPH, Doctorat' }
    ],
    requirements: {
      gpa: '3.8+',
      toefl: '100+',
      sat: '1450-1560',
      gre: '320+'
    },
    scholarships: [
      { name: 'Columbia Financial Aid', nameFr: 'Aide Financière Columbia', amount: 'Jusqu\'à 100%', amountEn: 'Up to 100%' },
      { name: 'International Fellowships', nameFr: 'Bourses Internationales', amount: '$20,000-$60,000', amountEn: '$20,000-$60,000' },
      { name: 'Graduate Scholarships', nameFr: 'Bourses de Cycles Supérieurs', amount: 'Variable', amountEn: 'Variable' }
    ],
    facilities: [
      { name: 'Bibliothèques', nameEn: 'Libraries', icon: 'ri-book-2-line' },
      { name: 'Centres de Recherche', nameEn: 'Research Centers', icon: 'ri-flask-line' },
      { name: 'Centres Sportifs', nameEn: 'Sports Centers', icon: 'ri-basketball-line' },
      { name: 'Résidences Étudiantes', nameEn: 'Student Housing', icon: 'ri-home-4-line' },
      { name: 'Centres Culturels', nameEn: 'Cultural Centers', icon: 'ri-palette-line' },
      { name: 'Centres de Carrière', nameEn: 'Career Centers', icon: 'ri-briefcase-line' }
    ]
  },
  {
    id: 'berkeley',
    name: 'University of California, Berkeley',
    location: 'Berkeley, California',
    image: 'https://readdy.ai/api/search-image?query=UC%20Berkeley%20campus%20with%20Sather%20Tower%20and%20green%20spaces%2C%20students%20studying%20outdoors%2C%20public%20research%20university%20atmosphere%2C%20California%20sunshine%2C%20diverse%20student%20body%2C%20professional%20photography%20style&width=1200&height=600&seq=univ-detail-005&orientation=landscape',
    ranking: '#4 Public',
    rankingEn: '#4 Public',
    founded: '1868',
    students: '45,000+',
    acceptance: '11.4%',
    tuition: '$44,000/an',
    tuitionEn: '$44,000/year',
    description: 'L\'University of California, Berkeley est une université publique de recherche de renommée mondiale. UC Berkeley est reconnue pour son excellence académique, sa recherche de pointe et son engagement envers l\'innovation sociale.',
    descriptionEn: 'The University of California, Berkeley is a world-renowned public research university. UC Berkeley is recognized for its academic excellence, cutting-edge research and commitment to social innovation.',
    programs: [
      { name: 'Engineering', nameFr: 'Ingénierie', degree: 'BS, MS, PhD', degreeFr: 'Licence, Master, Doctorat' },
      { name: 'Computer Science', nameFr: 'Informatique', degree: 'BS, MS, PhD', degreeFr: 'Licence, Master, Doctorat' },
      { name: 'Business', nameFr: 'Commerce', degree: 'BS, MBA', degreeFr: 'Licence, MBA' },
      { name: 'Social Sciences', nameFr: 'Sciences Sociales', degree: 'BA, MA, PhD', degreeFr: 'Licence, Master, Doctorat' },
      { name: 'Environmental Science', nameFr: 'Sciences Environnementales', degree: 'BS, MS, PhD', degreeFr: 'Licence, Master, Doctorat' },
      { name: 'Public Policy', nameFr: 'Politiques Publiques', degree: 'MPP, PhD', degreeFr: 'MPP, Doctorat' }
    ],
    requirements: {
      gpa: '3.7+',
      toefl: '90+',
      sat: '1330-1530',
      gre: '315+'
    },
    scholarships: [
      { name: 'Berkeley Financial Aid', nameFr: 'Aide Financière Berkeley', amount: 'Jusqu\'à 100%', amountEn: 'Up to 100%' },
      { name: 'International Scholarships', nameFr: 'Bourses Internationales', amount: '$10,000-$40,000', amountEn: '$10,000-$40,000' },
      { name: 'Graduate Fellowships', nameFr: 'Bourses de Cycles Supérieurs', amount: '$25,000-$45,000', amountEn: '$25,000-$45,000' }
    ],
    facilities: [
      { name: 'Bibliothèques', nameEn: 'Libraries', icon: 'ri-book-2-line' },
      { name: 'Laboratoires de Recherche', nameEn: 'Research Labs', icon: 'ri-flask-line' },
      { name: 'Centres Sportifs', nameEn: 'Sports Centers', icon: 'ri-basketball-line' },
      { name: 'Résidences Étudiantes', nameEn: 'Student Housing', icon: 'ri-home-4-line' },
      { name: 'Centres de Santé', nameEn: 'Health Centers', icon: 'ri-hospital-line' },
      { name: 'Musées', nameEn: 'Museums', icon: 'ri-building-line' }
    ]
  },
  {
    id: 'yale',
    name: 'Yale University',
    location: 'New Haven, Connecticut',
    image: 'https://readdy.ai/api/search-image?query=Yale%20University%20historic%20Gothic%20Revival%20architecture%20with%20stone%20buildings%20courtyards%20and%20towers%2C%20prestigious%20Ivy%20League%20campus%20in%20New%20Haven%20Connecticut%2C%20students%20walking%20on%20traditional%20university%20grounds%2C%20classic%20American%20collegiate%20architecture%2C%20autumn%20foliage%2C%20professional%20photography%20style%20with%20natural%20lighting&width=1200&height=600&seq=univ-yale-hero-001&orientation=landscape',
    ranking: '#5 Mondial',
    rankingEn: '#5 Worldwide',
    founded: '1701',
    students: '14,000+',
    acceptance: '4.5%',
    tuition: '$59,000/an',
    tuitionEn: '$59,000/year',
    description: 'Yale University est une université de recherche privée de l\'Ivy League reconnue pour son excellence en droit, arts et sciences humaines. Yale offre une éducation d\'élite dans un cadre historique magnifique avec une forte tradition d\'excellence académique.',
    descriptionEn: 'Yale University is a private Ivy League research university recognized for its excellence in law, arts and humanities. Yale offers elite education in a beautiful historic setting with a strong tradition of academic excellence.',
    programs: [
      { name: 'Law', nameFr: 'Droit', degree: 'JD, LLM, PhD', degreeFr: 'JD, LLM, Doctorat' },
      { name: 'Arts', nameFr: 'Arts', degree: 'BA, MFA', degreeFr: 'Licence, MFA' },
      { name: 'Humanities', nameFr: 'Sciences Humaines', degree: 'BA, MA, PhD', degreeFr: 'Licence, Master, Doctorat' },
      { name: 'Medicine', nameFr: 'Médecine', degree: 'MD, PhD', degreeFr: 'MD, Doctorat' },
      { name: 'Drama', nameFr: 'Théâtre', degree: 'MFA', degreeFr: 'MFA' },
      { name: 'Architecture', nameFr: 'Architecture', degree: 'MArch', degreeFr: 'MArch' }
    ],
    requirements: {
      gpa: '3.9+',
      toefl: '100+',
      sat: '1460-1580',
      gre: '320+'
    },
    scholarships: [
      { name: 'Yale Financial Aid', nameFr: 'Aide Financière Yale', amount: 'Jusqu\'à 100%', amountEn: 'Up to 100%' },
      { name: 'International Scholarships', nameFr: 'Bourses Internationales', amount: '$15,000-$59,000', amountEn: '$15,000-$59,000' },
      { name: 'Graduate Fellowships', nameFr: 'Bourses de Cycles Supérieurs', amount: 'Complète', amountEn: 'Full Coverage' }
    ],
    facilities: [
      { name: 'Bibliothèques', nameEn: 'Libraries', icon: 'ri-book-2-line' },
      { name: 'Musées d\'Art', nameEn: 'Art Museums', icon: 'ri-palette-line' },
      { name: 'Centres Sportifs', nameEn: 'Sports Centers', icon: 'ri-basketball-line' },
      { name: 'Résidences Étudiantes', nameEn: 'Student Housing', icon: 'ri-home-4-line' },
      { name: 'Théâtres', nameEn: 'Theaters', icon: 'ri-movie-line' },
      { name: 'Centres de Santé', nameEn: 'Health Centers', icon: 'ri-hospital-line' }
    ]
  },
  {
    id: 'shoreline',
    name: 'Shoreline Community College',
    location: 'Shoreline, Washington',
    image: 'https://readdy.ai/api/search-image?query=Shoreline%20Community%20College%20modern%20campus%20buildings%20with%20green%20spaces%20and%20diverse%20international%20students%2C%20Pacific%20Northwest%20setting%20with%20trees%20and%20contemporary%20architecture%2C%20welcoming%20community%20college%20atmosphere%2C%20professional%20photography%20style%2C%20bright%20natural%20lighting&width=1200&height=600&seq=univ-detail-007&orientation=landscape',
    ranking: 'Top Community College',
    rankingEn: 'Top Community College',
    founded: '1964',
    students: '12,000+',
    acceptance: '100%',
    tuition: '$10,000/an',
    tuitionEn: '$10,000/year',
    description: 'Shoreline Community College est un établissement d\'enseignement supérieur public situé dans l\'État de Washington, près de Seattle. Reconnu pour son excellence académique et son accueil chaleureux des étudiants internationaux, Shoreline offre des programmes Associate Degree de qualité et des parcours de transfert vers les meilleures universités américaines. C\'est une option abordable et accessible pour commencer vos études aux États-Unis.',
    descriptionEn: 'Shoreline Community College is a public higher education institution located in Washington State, near Seattle. Recognized for its academic excellence and warm welcome to international students, Shoreline offers quality Associate Degree programs and transfer pathways to top American universities. It is an affordable and accessible option to begin your studies in the United States.',
    programs: [
      { name: 'Business Administration', nameFr: 'Administration des Affaires', degree: 'Associate Degree', degreeFr: 'Associate Degree' },
      { name: 'Computer Science', nameFr: 'Informatique', degree: 'Associate Degree', degreeFr: 'Associate Degree' },
      { name: 'Engineering', nameFr: 'Ingénierie', degree: 'Associate Degree', degreeFr: 'Associate Degree' },
      { name: 'Liberal Arts', nameFr: 'Arts Libéraux', degree: 'Associate Degree', degreeFr: 'Associate Degree' },
      { name: 'Health Sciences', nameFr: 'Sciences de la Santé', degree: 'Associate Degree', degreeFr: 'Associate Degree' },
      { name: 'Biotechnology', nameFr: 'Biotechnologie', degree: 'Associate Degree', degreeFr: 'Associate Degree' },
      { name: 'Graphic Design', nameFr: 'Design Graphique', degree: 'Associate Degree', degreeFr: 'Associate Degree' },
      { name: 'Environmental Science', nameFr: 'Sciences Environnementales', degree: 'Associate Degree', degreeFr: 'Associate Degree' }
    ],
    requirements: {
      gpa: '2.5+',
      toefl: '61+',
      sat: 'Non requis',
      gre: 'Non requis'
    },
    scholarships: [
      { name: 'International Student Scholarships', nameFr: 'Bourses Étudiants Internationaux', amount: '$1,000-$3,000', amountEn: '$1,000-$3,000' },
      { name: 'Academic Excellence Awards', nameFr: 'Prix d\'Excellence Académique', amount: '$500-$2,000', amountEn: '$500-$2,000' },
      { name: 'Transfer Scholarships', nameFr: 'Bourses de Transfert', amount: '$1,500-$5,000', amountEn: '$1,500-$5,000' }
    ],
    facilities: [
      { name: 'Bibliothèques', nameEn: 'Libraries', icon: 'ri-book-2-line' },
      { name: 'Laboratoires Informatiques', nameEn: 'Computer Labs', icon: 'ri-computer-line' },
      { name: 'Centres Sportifs', nameEn: 'Sports Centers', icon: 'ri-basketball-line' },
      { name: 'Résidences Étudiantes', nameEn: 'Student Housing', icon: 'ri-home-4-line' },
      { name: 'Centre de Tutorat', nameEn: 'Tutoring Center', icon: 'ri-user-star-line' },
      { name: 'Centres de Carrière', nameEn: 'Career Centers', icon: 'ri-briefcase-line' }
    ]
  }
];

export default function UniversityPage() {
  const { id } = useParams();
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const isFrench = i18n.language === 'fr';
  
  const university = universitiesData.find(u => u.id === id);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  const handleContactClick = () => {
    navigate('/');
    setTimeout(() => {
      const contactSection = document.getElementById('contact');
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  const handleViewAllUniversities = () => {
    navigate('/');
    setTimeout(() => {
      const universitiesSection = document.getElementById('universities');
      if (universitiesSection) {
        universitiesSection.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  if (!university) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            {isFrench ? 'Université non trouvée' : 'University not found'}
          </h1>
          <Link to="/" className="text-teal-600 hover:text-teal-700 font-semibold cursor-pointer">
            {isFrench ? 'Retour à l\'accueil' : 'Back to home'}
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <div className="relative h-96 overflow-hidden">
        <img
          src={university.image}
          alt={university.name}
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-center text-white px-6">
            <h1 className="text-5xl lg:text-6xl font-bold mb-4">{university.name}</h1>
            <div className="flex items-center justify-center text-xl mb-4">
              <i className="ri-map-pin-line mr-2 w-6 h-6 flex items-center justify-center"></i>
              <span>{university.location}</span>
            </div>
            <div className="inline-block bg-teal-600 px-6 py-2 rounded-full text-lg font-semibold">
              {isFrench ? university.ranking : university.rankingEn}
            </div>
          </div>
        </div>
      </div>

      {/* Quick Stats */}
      <div className="bg-gray-50 py-12">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="text-4xl font-bold text-teal-600 mb-2">{university.founded}</div>
              <div className="text-gray-600">{isFrench ? 'Fondée' : 'Founded'}</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-teal-600 mb-2">{university.students}</div>
              <div className="text-gray-600">{isFrench ? 'Étudiants' : 'Students'}</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-teal-600 mb-2">{university.acceptance}</div>
              <div className="text-gray-600">{isFrench ? 'Taux d\'Admission' : 'Acceptance Rate'}</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-teal-600 mb-2">{isFrench ? university.tuition : university.tuitionEn}</div>
              <div className="text-gray-600">{isFrench ? 'Frais de Scolarité' : 'Tuition'}</div>
            </div>
          </div>
        </div>
      </div>

      {/* Description */}
      <div className="py-16">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">
            {isFrench ? 'À Propos de l\'Université' : 'About the University'}
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed">
            {isFrench ? university.description : university.descriptionEn}
          </p>
        </div>
      </div>

      {/* Programs */}
      <div className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
            {isFrench ? 'Programmes Disponibles' : 'Available Programs'}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {university.programs.map((program, index) => (
              <div key={index} className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-shadow">
                <div className="flex items-start mb-4">
                  <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mr-4">
                    <i className="ri-graduation-cap-line text-2xl text-teal-600 w-6 h-6 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">
                      {isFrench ? program.nameFr : program.name}
                    </h3>
                    <p className="text-gray-600">{isFrench ? program.degreeFr : program.degree}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Requirements */}
      <div className="py-16">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
            {isFrench ? 'Critères d\'Admission' : 'Admission Requirements'}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-gradient-to-br from-teal-50 to-teal-100 rounded-xl p-8 text-center">
              <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-file-list-3-line text-3xl text-white w-8 h-8 flex items-center justify-center"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">GPA</h3>
              <p className="text-2xl font-bold text-teal-600">{university.requirements.gpa}</p>
            </div>
            <div className="bg-gradient-to-br from-teal-50 to-teal-100 rounded-xl p-8 text-center">
              <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-translate-2 text-3xl text-white w-8 h-8 flex items-center justify-center"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">TOEFL</h3>
              <p className="text-2xl font-bold text-teal-600">{university.requirements.toefl}</p>
            </div>
            <div className="bg-gradient-to-br from-teal-50 to-teal-100 rounded-xl p-8 text-center">
              <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-pencil-line text-3xl text-white w-8 h-8 flex items-center justify-center"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">SAT</h3>
              <p className="text-2xl font-bold text-teal-600">{university.requirements.sat}</p>
            </div>
            <div className="bg-gradient-to-br from-teal-50 to-teal-100 rounded-xl p-8 text-center">
              <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-book-open-line text-3xl text-white w-8 h-8 flex items-center justify-center"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">GRE</h3>
              <p className="text-2xl font-bold text-teal-600">{university.requirements.gre}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Scholarships */}
      <div className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
            {isFrench ? 'Bourses Disponibles' : 'Available Scholarships'}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {university.scholarships.map((scholarship, index) => (
              <div key={index} className="bg-white rounded-xl p-8 shadow-md hover:shadow-xl transition-shadow">
                <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-money-dollar-circle-line text-3xl text-teal-600 w-8 h-8 flex items-center justify-center"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">
                  {isFrench ? scholarship.nameFr : scholarship.name}
                </h3>
                <p className="text-2xl font-bold text-teal-600 text-center">
                  {isFrench ? scholarship.amount : scholarship.amountEn}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Facilities */}
      <div className="py-16">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
            {isFrench ? 'Installations et Services' : 'Facilities & Services'}
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
            {university.facilities.map((facility, index) => (
              <div key={index} className="text-center">
                <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4 hover:bg-teal-200 transition-colors">
                  <i className={`${facility.icon} text-3xl text-teal-600 w-8 h-8 flex items-center justify-center`}></i>
                </div>
                <p className="text-sm font-semibold text-gray-900">
                  {isFrench ? facility.name : facility.nameEn}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="py-16 bg-gradient-to-r from-teal-600 to-teal-700">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6">
            {isFrench ? 'Intéressé par cette université ?' : 'Interested in this university?'}
          </h2>
          <p className="text-xl text-white/90 mb-8">
            {isFrench 
              ? 'Contactez-nous pour en savoir plus sur les programmes, les admissions et les bourses disponibles.'
              : 'Contact us to learn more about programs, admissions and available scholarships.'}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={handleContactClick}
              className="bg-white text-teal-600 px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              {isFrench ? 'Contactez-nous' : 'Contact Us'}
            </button>
            <button
              onClick={handleViewAllUniversities}
              className="bg-teal-800 text-white px-8 py-4 rounded-lg font-semibold hover:bg-teal-900 transition-colors whitespace-nowrap cursor-pointer"
            >
              {isFrench ? 'Voir Toutes les Universités' : 'View All Universities'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
